function AvailDetails () {
    return ( <></> );
}

export default AvailDetails ;